<template>
    <div id="main" ref="cockpit" :class="{ 'no-charts': !showCharts }">
        <div class="page">
            <!-- Barra Superior -->
            <div class="columns chart-toolbar is-multiline z-index-1">
                <!-- COLLAPSE DO FILTRO -->
                <div class="column">
                    <b-collapse class="card" :open="false">
                        <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                            <div class="card-header-title">
                                <div class="filtro-header">
                                    <b-icon :icon="props.open ? 'menu-down' : 'menu-right'" />
                                    <span class="is-size-7">{{ $t('filtros') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="columns is-multiline is-variable is-2">
                                <!-- COMBOS TIPO, VENDEDORES E EMPRESA -->
                                <div
                                    class="column is-full-touch is-full-desktop is-full-widescreen is-two-thirds-fullhd"
                                >
                                    <div class="columns is-variable is-2">
                                        <div class="column">
                                            <vss-select
                                                title="safra"
                                                v-model="safraSelected"
                                                extended
                                                compareId
                                                label="descricao"
                                                :options="safraSelect"
                                                :closeOnSelect="false"
                                                :loading="safraLoading"
                                                @search="loadSafra"
                                                @input="clearSelect($event, 'safras')"
                                                no-clearfix
                                                multiple
                                                clearable
                                                searchable
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                        <div v-if="empresaSelect.length > 0" class="column">
                                            <vss-select
                                                v-model="empresaSelected"
                                                title="empresas"
                                                extended
                                                compareId
                                                :closeOnSelect="false"
                                                :options="empresaSelect"
                                                @input="clearSelect($event, 'empresas')"
                                                no-clearfix
                                                multiple
                                                clearable
                                                :loading="empresasLoading"
                                                @search="carregarEmpresas"
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                        <div class="column">
                                            <vss-select
                                                title="vendedores"
                                                v-model="vendedorSelected"
                                                compareId
                                                label="nome"
                                                :closeOnSelect="false"
                                                extended
                                                :options="vendedorSelect"
                                                :loading="vendedoresLoading"
                                                @search="loadVendedores"
                                                @input="clearSelect($event, 'vendedores')"
                                                no-clearfix
                                                multiple
                                                clearable
                                                searchable
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                    </div>
                                </div>

                                <!-- DATAS -->
                                <div
                                    class="column is-full-touch is-full-desktop is-full-widescreen is-one-third-fullhd"
                                >
                                    <div class="columns is-variable is-2">
                                        <div class="column">
                                            <verified-date-picker
                                                dateType="startDate"
                                                v-model="dataInicio"
                                                :endDate="dataFim"
                                                :title="'data-inicio'"
                                                position="is-bottom-right"
                                                :invalid="erroDataInicio"
                                                :tooltipLabel="'informacao-filtro-data-inicial-cockpit'"
                                                tooltipSize="is-medium"
                                                tooltipPosition="is-bottom"
                                            />
                                        </div>
                                        <div class="column">
                                            <verified-date-picker
                                                dateType="endDate"
                                                v-model="dataFim"
                                                :startDate="dataInicio"
                                                :title="'data-fim'"
                                                position="is-bottom-right"
                                                :invalid="erroDataFim"
                                                :addDateYears="5"
                                                :tooltipLabel="'informacao-filtro-data-fim-cockpit'"
                                                tooltipSize="is-medium"
                                                tooltipPosition="is-bottom"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>

                <!-- BOTÕES -->
                <div class="column is-narrow">
                    <b-button
                        class="top-btn"
                        type="is-light"
                        @click="saveFiltros"
                        :disabled="isSavingFilter || isCleaningFilter"
                    >
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('aplicar-filtros') }}
                        </span>
                        <button-loader :isSaving="isSavingFilter" />
                    </b-button>

                    <b-button
                        class="top-btn"
                        type="is-light"
                        @click="confirmCleanFilters"
                        :disabled="isSavingFilter || isCleaningFilter"
                    >
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('limpar-filtros') }}
                        </span>
                        <button-loader :isSaving="isCleaningFilter" />
                    </b-button>

                    <b-button
                        class="top-btn"
                        icon-left="settings"
                        type="is-primary"
                        @click="openModalGraficos"
                        :disabled="isSavingFilter"
                    >
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('gerenciar-graficos') }}
                        </span>
                    </b-button>
                </div>
            </div>

            <div
                class="evo-card mr-3 pt-1"
                v-if="showCharts && dataset.some((e) => e.tipo == 'evolucao-vendas')"
            >
                <evolucao-vendas
                    :inicio="
                        $moment(
                            (filtroList.find((e) => e.tipo == 'data-inicio') || {}).valor
                        ).format('YYYY-MM-DD')
                    "
                    :fim="
                        $moment((filtroList.find((e) => e.tipo == 'data-fim') || {}).valor).format(
                            'YYYY-MM-DD'
                        )
                    "
                    :filtros="filtroList"
                    :vendedores-combo="
                        vendedorSelected.length > 0
                            ? Object.assign([], vendedorSelected)
                            : vendedorSelect
                    "
                    :safras-combo="
                        safraSelected.length > 0 ? Object.assign([], safraSelected) : safraSelect
                    "
                    @update-content="
                        updateChart(
                            $event,
                            dataset.findIndex((e) => e.tipo == 'evolucao-vendas')
                        )
                    "
                />
            </div>

            <!-- Gráficos -->
            <div class="chart-container mt-4 mr-3" ref="PackeryMagic" v-if="showCharts">
                <div class="pkry-gutter"></div>
                <div class="pkry-sizer"></div>
                <div
                    v-for="(d, i) in dataset"
                    :key="i"
                    class="chart"
                    ref="chartItem"
                    :class="{
                        'full-size-chart':
                            d &&
                            (d.titulo == 'chart-colaborador-cliente-atendimento-agrovisita' ||
                                d.titulo == 'chart-colaborador-visita-periodo-do-dia-agro' ||
                                d.titulo == 'chart-clientes-plano-safra-agro-visita'),
                        'big-number': d && d.tipo == 'bignumber',
                        speedometer: d && d.tipo == 'speedometer',
                        'line-chart':
                            d &&
                            (d.tipo == 'line' || d.tipo == 'bar' || d.tipo == 'zoombar') &&
                            d.titulo != 'chart-agro-cliente-cidade',
                        'is-invisible': d && d.tipo == 'evolucao-vendas',
                    }"
                    :data-title="d.titulo"
                    :data-item-id="i"
                >
                    <BigNumber
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bignumber'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="AGRO"
                        @update-content="updateChart($event, i)"
                    />
                    <GroupBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bar'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :direction="d.direction"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="AGRO"
                        @update-content="updateChart($event, i)"
                    />
                    <ZoomBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-else-if="d && d.tipo == 'zoombar'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :direction="d.direction"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="AGRO"
                        @update-content="updateChart($event, i)"
                    />
                    <DonutChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && (d.tipo == 'donut' || d.tipo == 'pie')"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :isPie="d.tipo == 'pie'"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="AGRO"
                        @update-content="updateChart($event, i)"
                    />
                    <FunnelChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'funnel'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="AGRO"
                        @update-content="updateChart($event, i)"
                    />
                </div>
            </div>

            <!-- Página não há dados -->
            <section class="hero is-fullheight" v-else-if="!isLoading">
                <div class="hero-body">
                    <div class="container has-text-centered">
                        <div class="elipse">
                            <svg class="big-svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/speedometer.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                        </div>
                        <p style="margin-top: 10px">
                            {{ $t('cockpit-sem-dados-vendas') }}
                        </p>
                        <button
                            class="button no-data-btn"
                            type="button"
                            @click="openModalGraficos"
                            style="margin-top: 10px"
                        >
                            {{ $t('gerenciar-graficos') }}
                        </button>
                    </div>
                </div>
            </section>

            <!-- Modal de gerenciar gráficos -->
            <b-modal :active.sync="isChartSelectOpen">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="title is-marginless is-paddingless">
                            {{ $t('add-graficos-cockpit') }}
                            <b-icon
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('sem-permissao-para-todas-as-acoes')"
                            />
                        </p>
                    </header>
                    <section
                        class="modal-card-body"
                        v-if="chartsAvailable && chartsAvailable.length > 0"
                    >
                        <div class="columns">
                            <div class="column">
                                <search-bar :onSearch="debouncedOnSearch" hideTitle />
                            </div>
                        </div>
                        <div class="columns is-mobile">
                            <div class="categorias column is-one-third">
                                <div class="columns is-multiline">
                                    <div class="column is-full">
                                        <span class="subtitle">{{ $t('categorias') }}</span>
                                    </div>
                                    <div
                                        class="column is-full"
                                        v-for="(c, i) in categorias"
                                        :key="i"
                                    >
                                        <a @click="filterCategoria(c.nome)">{{ $t(c.nome) }}</a>
                                        <span class="tag is-pulled-right">{{ c.qtd }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="result-set column">
                                <div class="columns is-multiline">
                                    <div
                                        class="column is-full"
                                        v-for="(c, i) in resultSet"
                                        :key="i"
                                    >
                                        <span class="subtitle has-text-justified">{{
                                            $t(c.nome)
                                        }}</span>
                                        <p class="has-text-justified" style="font-size: 12px">
                                            {{ getChartDesc(c) }}
                                        </p>
                                        <button
                                            v-if="isInCockpit(c) && permissao.delete"
                                            class="delete-btn"
                                            :class="c.isSaving ? 'disabled' : ''"
                                            @click="deleteChart(c)"
                                            :disabled="c.isSaving"
                                        >
                                            {{ $t('del-cockpit') }}
                                            <button-loader :isSaving="c.isSaving" />
                                        </button>
                                        <button
                                            v-else-if="permissao.create && !isInCockpit(c)"
                                            class="add-btn"
                                            :class="c.isSaving ? 'disabled' : ''"
                                            @click="addChart(c)"
                                            :disabled="c.isSaving"
                                        >
                                            {{ $t('add-cockpit') }}
                                            <button-loader :isSaving="c.isSaving" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section v-else>
                        <div class="columns">
                            <div class="no-results column">
                                {{ $t('sem-graficos') }}
                            </div>
                        </div>
                    </section>
                </div>
            </b-modal>
        </div>
        <br style="clear: both" /><br />
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import CockpitAgroService from '@/services/agro/cockpit/CockpitAgroService';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import SafraService from '@/services/agro/SafraService';
import HelperCard from '@/components/shared/HelperCard';
import DonutChart from '@/components/shared/chart/DonutChart';
import BigNumber from '@/components/shared/chart/BigNumber';
import GroupBarChart from '@/components/shared/chart/GroupBarChart';
import FunnelChart from '@/components/shared/chart/FunnelChart';
import ZoomBarChart from '@/components/shared/chart/ZoomBarChart';
import FiltroCockpitService from '@/services/FiltroCockpitService';
import $ from 'jquery';
import * as Draggable from 'jquery-ui/ui/widgets/draggable.js';
import Packery from 'packery';

export default {
    components: {
        HelperCard,
        DonutChart,
        GroupBarChart,
        BigNumber,
        FunnelChart,
        ZoomBarChart,
    },
    data() {
        return {
            day_names: [
                this.$t('dom'),
                this.$t('seg'),
                this.$t('ter'),
                this.$t('qua'),
                this.$t('qui'),
                this.$t('sex'),
                this.$t('sab'),
            ],
            month_names: [
                this.$t('january'),
                this.$t('february'),
                this.$t('march'),
                this.$t('april'),
                this.$t('may'),
                this.$t('june'),
                this.$t('july'),
                this.$t('august'),
                this.$t('september'),
                this.$t('october'),
                this.$t('november'),
                this.$t('december'),
            ],
            jqi: $,
            filtroCockpitService: new FiltroCockpitService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            service: new CockpitAgroService(this.$http, this.$router),
            colaboradorService: new GerenciarUsuariosService(this.$http, this.$router),
            safraService: new SafraService(this.$http, this.$router),
            dataset: [],
            lastSize: { w: 0, h: 0 },
            isLoading: false,
            isChartSelectOpen: false,
            chartsAvailable: [],
            categorias: [],
            searchSet: [],
            resultSet: [],
            searching: false,
            charts: [],
            pckr: null,
            newCharts: [],
            layout: {
                tipo: 'agro',
                grande: { tipo: 'agro' },
                medio: { tipo: 'agro' },
                pequeno: { tipo: 'agro' },
            },
            dragOpts: {
                zIndex: 100,
                handle: '.chart-title',
                containment: '.chart-container',
            },
            firstReload: false,
            curScreenSize: 1201,
            prevScreenSize: 1201,
            loadedPositions: false,
            packeryOpts: {
                itemSelector: '.chart',
                percentPosition: true,
                shiftPercentResize: true,
                transitionDuration: '0.3s',
                gutter: '.pkry-gutter',
                columnWidth: '.pkry-sizer',
            },
            isSavingFilter: false,
            isCleaningFilter: false,

            vendedorSelect: [],
            vendedorSelected: [],
            vendedoresLoading: false,

            empresaSelect: [],
            empresaSelected: [],

            safraSelect: [],
            safraSelected: [],
            safraLoading: false,

            filtroList: [],
            filtros: {
                empresa: [],
                vendedor: [],
                safra: [],
                /*  Para as datas, seta o valor inicial, se vier algo diferente do banco
                    eles serão sobreescritos após carregar os filtros. */
                datainicio: null,
                datafim: null,
            },

            dataInicio: new Date(this.$moment().subtract(30, 'days')),
            dataFim: new Date(),
            staticDataInicial: undefined,
            staticDataFinal: undefined,
            showCharts: false,
            permissao: {},
            erroDataInicio: false,
            erroDataFim: false,
            empresasLoading: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('agro', 'cockpit', 'agro-cockpit');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-cockpit-titulo' },
            });
        }

        if (this.permissao.read) {
            this.dataFim = new Date(this.$moment(this.dataFim).local());
            this.dataInicio = new Date(this.$moment(this.dataInicio).local());

            this.staticDataInicial = this.dataInicio;
            this.staticDataFinal = this.dataFim;
            this.filtros.datainicio = this.$moment(this.dataInicio).local();
            this.filtros.datafim = this.$moment(this.dataFim).local();

            this.isLoading = true;

            this.loadVendedores('', true);
            this.loadSafra('', true);
            this.carregarEmpresas('');
            this.carregarCartoes();

            let body = document.getElementsByTagName('body')[0];
            this.curScreenSize = window.innerWidth;
            this.prevScreenSize = window.innerWidth;

            this.lastSize.w = document.body.clientWidth;
            this.lastSize.h = document.body.clientHeight;

            body.onresize = this.debounce(this.resize, 150);
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.debouncedRedraw = this.debounce(this.redrawCharts, 1000);

            setTimeout(() => {
                this.saveChartPositions();
            }, 2000);

            this.chartsAvailable = [
                {
                    nome: 'chart-clientes-visita',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-visita-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-atendimento-por-motivo',
                    categoria: 'atendimentos',
                    descricao: 'chart-atendimento-por-motivo-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-atendimento-por-assunto',
                    categoria: 'atendimentos',
                    descricao: 'chart-atendimento-por-assunto-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-colaborador-cliente-atendimento-agrovisita',
                    categoria: 'atendimentos',
                    descricao: 'chart-colaborador-cliente-atendimento-agrovisita-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-visitas-empresa-agro',
                    categoria: 'atendimentos',
                    descricao: 'chart-visitas-empresa-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-colaborador-visita-periodo-do-dia-agro',
                    categoria: 'atendimentos',
                    descricao: 'chart-colaborador-visita-periodo-do-dia-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-cultura-safra',
                    categoria: 'cultura',
                    descricao: 'chart-cultura-safra-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-ocorrencia',
                    categoria: 'atendimentos',
                    descricao: 'chart-ocorrencia-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-agro-cliente-por-vendedor',
                    categoria: 'clientes',
                    descricao: 'chart-agro-cliente-por-vendedor-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-agro-cliente-cidade',
                    categoria: 'clientes',
                    descricao: 'chart-agro-cliente-cidade-descricao',
                },
                {
                    nome: 'chart-visitas-colaborador-agro',
                    categoria: 'atendimentos',
                    descricao: 'chart-visitas-colaborador-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-agro-atendimentos',
                    categoria: 'atendimentos',
                    descricao: 'chart-agro-atendimentos-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-plano-safra-agro-visita',
                    categoria: 'cultura',
                    descricao: 'chart-cultura-safra-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-agro-clientes-atendimentos',
                    categoria: 'atendimentos',
                    descricao: 'chart-agro-clientes-atendimentos-descricao',
                    isSaving: false,
                },
            ];
        }
    },
    beforeDestroy() {
        this.mapToSaveChart();
    },
    methods: {
        clearInputs() {
            this.empresaSelected = [];
            this.vendedorSelected = [];
            this.safraSelected = [];
            this.filtros.empresa = this.empresaSelect.map((e) => e.id);
            this.filtros.vendedor = this.vendedorSelect.map((e) => e.id);
            this.filtros.safra = [];
            this.filtros.datainicio = this.staticDataInicial;
            this.dataInicio = new Date(this.staticDataInicial);
            this.filtros.datafim = this.staticDataFinal;
            this.dataFim = new Date(this.staticDataFinal);
            this.existeFiltrosSelecionado = false;

            this.isCleaningFilter = false;
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == 'empresas') {
                    this.empresaSelected = [];
                    this.filtros.empresa = this.empresaSelect.map((e) => e.id);
                } else if (select == 'vendedores') {
                    this.vendedorSelected = [];
                    this.filtros.vendedor = this.vendedorSelect.map((e) => e.id);
                } else if (select == 'safras') {
                    this.safraSelected = [];
                    this.filtros.safra = [];
                }
            }
        },
        confirmCleanFilters() {
            this.isCleaningFilter = true;
            if (this.possuiFiltroSelecionado()) {
                this.$root.confirm({
                    message: this.$t('msg-confirm-limpar-filtros'),
                    onConfirm: this.clearFilters,
                    onCancel: () => (this.isCleaningFilter = false),
                });
            } else {
                this.clearInputs();
            }
        },
        possuiFiltroSelecionado() {
            return this.filtros.safra.length < this.safraSelect.length ||
                this.filtros.empresa.length < this.empresaSelect.length ||
                this.filtros.vendedor.length < this.vendedorSelect.length ||
                this.filtros.datainicio !== this.staticDataInicial ||
                this.filtros.datafim !== this.staticDataFinal
                ? true
                : false;
        },
        clearFilters() {
            this.safraSelected = [];
            this.empresaSelected = [];
            this.vendedorSelected = [];
            this.filtros.safra = [];
            this.filtros.empresa = this.empresaSelect.map((e) => e.id);
            this.filtros.vendedor = this.vendedorSelect.map((e) => e.id);
            this.filtros.datainicio = this.staticDataInicial;
            this.dataInicio = new Date(this.staticDataInicial);
            this.filtros.datafim = this.staticDataFinal;
            this.dataFim = new Date(this.staticDataFinal);
            this.existeFiltrosSelecionado = false;
            this.saveFiltros();
        },
        // Início dos services dos filtros
        // Para verificar os vendedores pela primeira vez e verificar se precisa mostrar o combo ou não
        loadVendedores(q = '', startVendedores = false) {
            if (startVendedores) this.$store.commit('addLoader');
            this.vendedoresLoading = true;

            this.colaboradorService
                .findAllCombo(q)
                .then((r) => {
                    this.vendedorSelect = r.content;
                    if (startVendedores)
                        this.filtros.vendedor = this.vendedorSelect.map((e) => e.id);
                })
                .catch((e) => {
                    console.error('Erro ao carregar vendedor.', e);
                })
                .finally((_) => {
                    if (startVendedores) this.$store.commit('removeLoader');
                    this.vendedoresLoading = false;
                });
        },
        loadSafra(q = '', startSafra = false) {
            if (startSafra) this.$store.commit('addLoader');
            this.safraLoading = true;

            this.safraService
                .findAllCombo(q)
                .then((r) => {
                    this.safraSelect = r.content;
                    if (startSafra) this.filtros.safra = [];
                })
                .catch((e) => {
                    console.error('Erro ao carregar safra.', e);
                })
                .finally((_) => {
                    if (startSafra) this.$store.commit('removeLoader');
                    this.safraLoading = false;
                });
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findAllCombo()
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[COCK PIT AGRO] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[COCK PIT AGRO] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('[COCK PIT AGRO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresasLoading = false;
                });
        },
        // Fim dos services dos filtros

        resize() {
            let currentSize = {
                w: document.body.clientWidth,
                h: document.body.clientHeight,
            };
            this.curScreenSize = window.innerWidth;

            if (currentSize.w != this.lastSize.w) {
                this.redrawCharts();
            }

            this.lastSize = currentSize;
        },
        redrawCharts() {
            this.$d3.selectAll('.chart-tooltip').remove();
            this.charts.forEach((c) => {
                let component = this.$refs[`${c.tipo}-${c.titulo}`];
                if (component && component[0]) {
                    component[0].redrawChart();
                }
            });
            this.mountCockpitCharts();
        },
        closeAllFilters() {
            this.charts.forEach((c) => {
                let component = this.$refs[`${c.tipo}-${c.titulo}`];
                if (component && component[0]) {
                    let el = component[0].$refs;
                    if (el.chartFilter != undefined) {
                        el.chartFilter.popoverShow = false;
                    }
                }
            });
        },
        carregarCartoes() {
            this.$store.commit('addLoader');
            this.filtroCockpitService
                .buscarGraficosComFiltros('agro')
                .then((res) => {
                    this.filtroList = res.content.filtros;
                    this.getFiltroObject();
                    if (this.vendedorSelected.length > 0) {
                        this.vendedoresResultadoAtual = [...this.vendedorSelected];
                    } else {
                        this.vendedoresResultadoAtual = [...this.vendedorSelect];
                    }
                    this.charts = res.content.charts;
                    this.loadAll();
                })
                .catch((e) => {
                    console.error('Erro ao carregar os cards.', e);
                    this.$root.showMessage('error', 'msg-erro-cockpit');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        /*  Transformar a list do filtroList para o objeto de filtros. */
        getFiltroObject() {
            this.filtroList.forEach((f) => {
                switch (f.tipo) {
                    case 'safra':
                        if (f.itens != null && f.itens.length > 0)
                            this.filtros.safra = f.itens.map((e) => e.id);
                        this.safraSelected = f.itens;
                        this.filtros.idfiltrosafra = f.idfiltro;
                        break;
                    case 'empresa':
                        if (f.itens != null && f.itens.length > 0)
                            this.filtros.empresa = f.itens.map((e) => e.id);
                        this.empresaSelected = f.itens;
                        this.filtros.idfiltroempresa = f.idfiltro;
                        break;
                    case 'vendedor':
                        if (f.itens != null && f.itens.length > 0)
                            this.filtros.vendedor = f.itens.map((e) => e.id);
                        this.vendedorSelected = f.itens;
                        this.filtros.idfiltrovendedor = f.idfiltro;
                        break;
                    case 'data-inicio':
                        this.dataInicio = this.$moment(f.valor).toDate();
                        this.filtros.datainicio = f.valor;
                        this.filtros.idfiltrodatainicio = f.idfiltro;
                        break;
                    case 'data-fim':
                        this.dataFim = this.$moment(f.valor).toDate();
                        this.filtros.datafim = f.valor;
                        this.filtros.idfiltrodatafim = f.idfiltro;
                        break;
                }
            });
        },
        getFiltroServer() {
            let filtros = {};
            if (this.filtroList && this.filtroList.length > 0) {
                this.filtroList.forEach((f) => {
                    switch (f.tipo) {
                        case 'safra':
                            filtros.safra =
                                f.itens != null
                                    ? f.itens.map((e) => (typeof e == 'number' ? e : e.id))
                                    : [];
                            break;
                        case 'empresa':
                            filtros.empresa =
                                f.itens != null
                                    ? f.itens.map((e) => (typeof e == 'number' ? e : e.id))
                                    : [];
                            break;
                        case 'vendedor':
                            filtros.vendedor =
                                f.itens != null
                                    ? f.itens.map((e) => (typeof e == 'number' ? e : e.id))
                                    : [];
                            break;
                        case 'data-inicio':
                            filtros.datainicio = f.valor;
                            break;
                        case 'data-fim':
                            filtros.datafim = f.valor;
                            break;
                    }
                });
            } else {
                return this.filtros;
            }
            return filtros;
        },
        getFiltroList() {
            this.filtros.empresa = this.empresaSelected.map((e) => Number(e.id));
            this.filtros.vendedor = this.vendedorSelected.map((e) => Number(e.id));
            this.filtros.safra = this.safraSelected.map((e) => Number(e.id));

            this.filtros.datainicio = this.dataInicio;
            this.filtros.datafim = this.dataFim;

            let filtros = [];

            filtros.push({
                idfiltro: this.filtros.idfiltroempresa,
                tipo: 'empresa',
                multi: true,
                itens: this.filtros.empresa,
            });

            filtros.push({
                idfiltro: this.filtros.idfiltrovendedor,
                tipo: 'vendedor',
                multi: true,
                itens: this.filtros.vendedor,
            });

            filtros.push({
                idfiltro: this.filtros.idfiltrosafra,
                tipo: 'safra',
                multi: true,
                itens: this.filtros.safra,
            });

            filtros.push({
                idfiltro: this.filtros.idfiltrodatainicio,
                tipo: 'data-inicio',
                multi: false,
                valor: this.filtros.datainicio,
            });
            filtros.push({
                idfiltro: this.filtros.idfiltrodatafim,
                tipo: 'data-fim',
                multi: false,
                valor: this.filtros.datafim,
            });
            return filtros;
        },
        loadAll() {
            let body = document.getElementsByTagName('body')[0];
            this.dataset = [...this.charts];
            // this.mapStackChart();
            if (body.offsetWidth > 760 && body.offsetWidth < 861) {
                let line = this.dataset.filter((d) => d.tipo == 'line')[0];
                let i = this.dataset.indexOf(line);
                if (i > -1) {
                    this.dataset.splice(this.dataset.indexOf(line), 1);
                    this.dataset.push(line);
                }
            }
            // Mostrar os charts
            this.showCharts = this.dataset.length > 0;

            this.mountCockpitCharts();
        },
        mapToSaveChart() {
            if (this.layout.grande) {
                if (typeof this.layout.grande.datacontent != 'string') {
                    this.layout.grande.datacontent = JSON.stringify(this.layout.grande.datacontent);
                }
                this.layout.grande.tamanho = 'grande';
            }
            if (this.layout.medio) {
                if (typeof this.layout.medio.datacontent != 'string') {
                    this.layout.medio.datacontent = JSON.stringify(this.layout.medio.datacontent);
                }
                this.layout.medio.tamanho = 'medio';
            }
            if (this.layout.pequeno) {
                if (typeof this.layout.pequeno.datacontent != 'string') {
                    this.layout.pequeno.datacontent = JSON.stringify(
                        this.layout.pequeno.datacontent
                    );
                }
                this.layout.pequeno.tamanho = 'pequeno';
            }
            // Estava no BeforeDestroy
            this.service.saveChartLayout(this.layout);
            document.body.onresize = null;
        },
        mountCockpitCharts() {
            setTimeout(() => {
                if (this.$refs.chartItem && this.$refs.chartItem.length > 0) {
                    if (this.pckr != null) this.pckr.destroy();
                    let elemPack = this.$refs.PackeryMagic;
                    if (this.loadedPositions) {
                        setTimeout(() => {
                            this.getChartPositions(elemPack, this.layout);
                        }, 1000);
                    } else {
                        this.$store.commit('addLoader');
                        this.service
                            .getChartLayout(this.layout.tipo)
                            .then((l) => {
                                if (l) {
                                    this.layout = l;
                                }
                                var initPositions = this.layout;
                                if (initPositions) {
                                    this.packeryOpts.layout = false;
                                }
                                setTimeout(() => {
                                    this.getChartPositions(elemPack, initPositions);
                                }, 1000);
                                this.loadedPositions = true;
                            })
                            .finally((_) => {
                                this.$store.commit('removeLoader');
                            });
                    }
                } else {
                    if (this.pckr != null) {
                        this.pckr.destroy();
                        this.pckr = null;
                    }
                }
                setTimeout(() => {
                    this.addNewChartPosition();
                }, 200);
            }, 100);
        },
        // Métodos do gerenciamento de gráficos
        filterCategoria(nome) {
            if (this.searching) {
                this.resultSet = this.searchSet.filter((c) => {
                    return c.categoria == nome;
                });
            } else {
                this.resultSet = this.chartsAvailable.filter((c) => {
                    return c.categoria == nome;
                });
            }
        },
        isInCockpit(c) {
            return this.dataset.find((e) => {
                return e.titulo == c.nome;
            });
        },
        getCategories() {
            // Usado dentro de gerenciar gŕaficos
            this.categorias = [];
            this.resultSet.forEach((c) => {
                var index = this.categorias.findIndex((e) => {
                    return e.nome == c.categoria;
                });
                if (index < 0) {
                    this.categorias.push({
                        nome: c.categoria,
                        qtd: 1,
                    });
                } else {
                    this.categorias[index].qtd++;
                }
            });
        },
        getChartPositions(elemPack, initPositions) {
            this.pckr = new Packery(elemPack, this.packeryOpts);
            this.pckr.on('dragItemPositioned', (abc) => {
                this.firstReload = true;
                var positions = this.pckr.getShiftPositions('data-item-id');
                if (this.curScreenSize > 1200) {
                    if (this.layout.grande) {
                        this.layout.grande.datacontent = positions;
                        this.layout.grande.tipo = 'agro';
                    } else {
                        this.layout.grande = { datacontent: positions, tipo: 'agro' };
                    }
                } else if (this.curScreenSize < 760) {
                    if (this.layout.pequeno) {
                        this.layout.pequeno.datacontent = positions;
                        this.layout.pequeno.tipo = 'agro';
                    } else {
                        this.layout.pequeno = { datacontent: positions, tipo: 'agro' };
                    }
                } else {
                    if (this.layout.medio) {
                        this.layout.medio.datacontent = positions;
                        this.layout.medio.tipo = 'agro';
                    } else {
                        this.layout.medio = { datacontent: positions, tipo: 'agro' };
                    }
                }
            });

            this.$refs.chartItem.forEach((c) => {
                c.draggable = new Draggable(this.dragOpts, c);
                this.bindDraggables(c);
            });

            let layout = null;
            if (initPositions) {
                if (this.curScreenSize > 1200) {
                    if (initPositions.grande) {
                        if (initPositions.grande.datacontent != '') {
                            if (initPositions.grande.datacontent === String) {
                                layout = JSON.parse(initPositions.grande.datacontent);
                            }

                            if (layout != null && layout.length == this.dataset.length) {
                                this.pckr.initShiftLayout(
                                    initPositions.grande.datacontent,
                                    'data-item-id'
                                );
                            } else {
                                this.pckr.shiftLayout();
                            }
                        } else {
                            this.pckr.shiftLayout();
                        }
                    } else {
                        this.pckr.shiftLayout();
                    }
                } else if (this.curScreenSize < 760) {
                    if (initPositions.pequeno) {
                        if (initPositions.pequeno.datacontent != '') {
                            if (initPositions.pequeno.datacontent === String) {
                                layout = JSON.parse(initPositions.pequeno.datacontent);
                            }

                            if (layout != null && layout.length == this.dataset.length) {
                                this.pckr.initShiftLayout(
                                    initPositions.pequeno.datacontent,
                                    'data-item-id'
                                );
                            } else {
                                this.pckr.shiftLayout();
                            }
                        } else {
                            this.pckr.shiftLayout();
                        }
                    } else {
                        this.pckr.shiftLayout();
                    }
                } else {
                    if (initPositions.medio) {
                        if (initPositions.medio.datacontent != '') {
                            if (initPositions.medio.datacontent === String) {
                                layout = JSON.parse(initPositions.medio.datacontent);
                            }

                            if (layout != null && layout.length == this.dataset.length) {
                                this.pckr.initShiftLayout(
                                    initPositions.medio.datacontent,
                                    'data-item-id'
                                );
                            } else {
                                this.pckr.shiftLayout();
                            }
                        } else {
                            this.pckr.shiftLayout();
                        }
                    } else {
                        this.pckr.shiftLayout();
                    }
                }
            }
        },
        onSearch(value) {
            var searchValue = value.trim();
            if (searchValue != '') {
                this.searching = true;
                this.resultSet = this.chartsAvailable.filter((c) => {
                    return this.$t(c.nome).search(new RegExp(searchValue, 'i')) > -1;
                });
                this.searchSet = this.resultSet;
            } else {
                this.searching = false;
                this.resultSet = this.chartsAvailable;
            }
            this.getCategories();
        },
        deleteChart(c) {
            c.isSaving = true;
            let index = this.dataset.findIndex((e) => {
                return e.titulo == c.nome;
            });
            if (index > -1 && this.dataset[index] && this.dataset[index].id > 0) {
                this.service.delete(this.dataset[index].id).then((res) => {
                    if (res) {
                        this.dataset.splice(index, 1);
                        this.charts.splice(index, 1);
                        c.isSaving = false;
                        this.debouncedRedraw();

                        // Salva posição dos gráficos toda vez que um gráfico é removido.
                        this.saveChartPositions();
                        this.mapToSaveChart();
                    }
                });
            }
        },
        addChart(c) {
            c.isSaving = true;
            this.firstReload = true;
            switch (c.nome) {
                case 'chart-clientes-visita':
                    this.service
                        .getClientesVisita(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-atendimento-por-motivo':
                    this.service
                        .getAtendimentoPorMotivo(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-atendimento-por-assunto':
                    this.service
                        .getAtendimentoPorAssunto(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-cultura-safra':
                    this.service
                        .getCulturaSafra(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-ocorrencia':
                    this.service
                        .getOcorrencia(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-colaborador-cliente-atendimento-agrovisita':
                    this.service
                        .getColaboradorClienteAtendimentoAgrovisita(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-visitas-empresa-agro':
                    this.service
                        .getVisitasEmpresa(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-agro-cliente-por-vendedor':
                    this.service
                        .getClientesPorVendedor(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-agro-cliente-cidade':
                    this.service
                        .getClientePorCidade(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-visitas-colaborador-agro':
                    this.service
                        .getVisitaColaborador(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-colaborador-visita-periodo-do-dia-agro':
                    this.service
                        .getColaboradorVisitaPeriodoDia(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-agro-atendimentos':
                    this.service
                        .getChartAgroAtendimentos(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-plano-safra-agro-visita':
                    this.service
                        .getClientePlanoSafraAgroVisita(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-agro-clientes-atendimentos':
                    this.service
                        .getClientesAtendimentos(this.getFiltroServer())
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
            }
        },
        saveFiltros() {
            this.isSavingFilter = true;
            let erroFiltro = false;

            this.filtros.datainicio = this.dataInicio;
            this.filtros.datafim = this.dataFim;

            /**
             * @70409 - Verificando se as datas estão vazias.
             */
            if (this.filtros.datainicio == null) {
                this.erroDataInicio = true;
                erroFiltro = true;
            } else {
                this.erroDataInicio = false;
            }

            if (this.filtros.datafim == null) {
                this.erroDataFim = true;
                erroFiltro = true;
            } else {
                this.erroDataFim = false;
            }

            if (erroFiltro) {
                this.$root.showMessage('alert', 'datas-obrigatorias');
                this.isSavingFilter = false;
                this.isCleaningFilter = false;
                return;
            }

            this.filtroList = this.getFiltroList();
            this.filtroCockpitService
                .save(this.filtroList, 'agro')
                .then((r) => {
                    this.reloadCharts();
                })
                .catch((e) => {
                    console.error('Erro ao salvar filtros.', e);
                    this.$root.showMessage('error', 'msg-erro-filtros');
                });
        },
        reloadCharts() {
            // Após salvar os filtros os charts são recarregados
            this.charts
                .filter((e) => e.tipo != 'evolucao-vendas')
                .forEach((c) => {
                    let component = this.$refs[`${c.tipo}-${c.titulo}`][0];
                    /* Não são todos os charts que tem o cleanChart() */
                    if (component) {
                        if (component.cleanChart) {
                            component.cleanChart();
                        }
                        component.loadData();
                    }
                });
            setTimeout(() => {
                this.isSavingFilter = false;
                this.isCleaningFilter = false;
            }, 1000);
        },
        pushIntoDataset(data) {
            this.charts.push(data);
            this.dataset.push(data);
            this.showCharts = this.dataset.length > 0;
            setTimeout(() => {
                if (this.charts.length > 1) {
                    let el = this.$refs[`${data.tipo}-${data.titulo}`][0].$el.parentElement;
                    this.newCharts.push(el);
                    this.pckr.appended(el);
                    this.addNewChartPosition();
                    setTimeout(() => {
                        this.redrawCharts();
                    }, 50);
                } else {
                    this.mountCockpitCharts();
                }

                // Salva posição dos gráficos toda vez que um novo é adicionado.
                this.saveChartPositions();
                this.mapToSaveChart();
            }, 50);
        },
        openModalGraficos() {
            // Usado dentro de gerenciar gŕaficos
            this.resultSet = this.chartsAvailable;
            this.getCategories();
            this.isChartSelectOpen = true;
        },
        getChartDesc(c) {
            // Usado dentro de gerenciar gŕaficos
            if (c.descricao != null || c.descricao != undefined) {
                return this.$t(c.descricao) ? this.$t(c.descricao) : this.$t('chart-no-desc');
            } else {
                console.warn('Descrição inexistente para ' + c.nome);
                return this.$t('chart-no-desc');
            }
        },
        addNewChartPosition() {
            if (this.pckr != null) {
                let positions = undefined;
                positions = this.pckr.getShiftPositions('data-item-id');
                if (this.curScreenSize > 1200) {
                    if (this.layout.grande) {
                        this.layout.grande.datacontent = positions;
                        this.layout.grande.tipo = 'agro';
                    } else {
                        this.layout.grande = { datacontent: positions, tipo: 'agro' };
                    }
                } else if (this.curScreenSize < 760) {
                    if (this.layout.pequeno) {
                        this.layout.pequeno.datacontent = positions;
                        this.layout.pequeno.tipo = 'agro';
                    } else {
                        this.layout.pequeno = { datacontent: positions, tipo: 'agro' };
                    }
                } else {
                    if (this.layout.medio) {
                        this.layout.medio.datacontent = positions;
                        this.layout.medio.tipo = 'agro';
                    } else {
                        this.layout.medio = { datacontent: positions, tipo: 'agro' };
                    }
                }
            }
        },
        saveChartPositions() {
            // get JSON-friendly data for items positions
            Packery.prototype.getShiftPositions = function (attrName) {
                attrName = attrName || 'id';
                let _this = this;
                return this.items.map(function (item) {
                    return {
                        attr: item.element.getAttribute(attrName),
                        x: item.rect.x / _this.packer.width,
                    };
                });
            };
            Packery.prototype.initShiftLayout = function (positions, attr) {
                let _this = this;
                if (!positions) {
                    // if no initial positions, run packery layout
                    _this.layout();
                    return;
                }
                // parse string to JSON
                if (typeof positions == 'string') {
                    try {
                        positions = JSON.parse(positions);
                    } catch (error) {
                        console.error('JSON parse error:', error, positions);
                        _this.layout();
                        return;
                    }
                }
                attr = attr || 'id'; // default to id attribute
                _this._resetLayout();
                // set item order and horizontal position from saved positions
                _this.items = positions.map(function (itemPosition) {
                    var selector = '[' + attr + '="' + itemPosition.attr + '"]';
                    var itemElem = _this.element.querySelector(selector);
                    var item = _this.getItem(itemElem);
                    item.rect.x = itemPosition.x * _this.packer.width;
                    return item;
                }, _this);
                _this.shiftLayout();
            };
            Packery.Item.prototype.setPosition = function (x, y) {
                if (x > 0) {
                    this.position.x = parseFloat(x) - 0.07;
                } else {
                    this.position.x = parseFloat(x);
                }
                this.position.y = parseFloat(y);
            };
        },
        bindDraggables(elem) {
            this.jqi(elem).on('dragstart', this.pckr.handleUIDraggable.start);
            this.jqi(elem).on('dragstart', this.closeAllFilters);
            this.jqi(elem).on('drag', this.pckr.handleUIDraggable.drag);
            this.jqi(elem).on('dragstop', this.pckr.handleUIDraggable.stop);
        },
        /*  Esta função serve para poder atualizar o conteúdo do card aqui
            ao invés de alterar a prop dentro do componente dele. */
        updateChart(datacontent, index) {
            this.$set(this.dataset, index, datacontent);
        },
        handleDateChange(nova_data, campo) {
            switch (campo) {
                case 'inicio':
                    this.filtros.datainicio = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
                case 'fim':
                    this.filtros.datafim = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
            }
        },
        showInfo(tituloCockpit) {
            if (this.$te(`info-${tituloCockpit}`)) {
                return this.$t(`info-${tituloCockpit}`);
            } else {
                return null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.z-index-1 {
    z-index: 1;
}

#main {
    padding: 0 15px 15px 21px;
    height: auto;

    &.no-charts {
        height: 100%;
    }
}

img {
    width: 240px;
    height: 360px;
}

.page {
    position: relative;
    padding-left: 0;
    background: none;
    box-shadow: none;
}

.hero.is-fullheight {
    min-height: calc(100% - 20px);
}

.chart-toolbar .column .card {
    overflow: initial;
}

.footer {
    position: relative;
    bottom: 20px;
    width: 100%;
    /* top: calc(100% - 450px); */
    max-height: 300px;
    display: flex;
    justify-content: space-between;
}

.cockpit {
    position: relative;
    width: 100%;
    margin-bottom: 120px;
}

.cockpit .center p {
    height: 100%;
    margin-bottom: 40px;
    font-size: 20px;
    color: $text-color;
    width: 50%;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
}

.cockpit .center .btn {
    color: $sovis-white;
    padding: 10px 70px;
}

.cockpit .center .elipse {
    margin-bottom: 40px;
    > .big-svg-icons {
        width: 250px;
        height: 125px;
        margin-top: -10px;
    }
}
.no-charts .center {
    top: 50%;
    transform: translate(-50%, -50%);

    .elipse {
        margin-bottom: 20px;
    }
    .big-svg-icons {
        top: 45%;
    }
}

// Modal adicionar gráfico ao cockpit
.modal-card-body .subtitle {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 16px;
    color: $primary-color;
}

.manage-charts-link {
    font-size: 14px;
}

.manage-charts-shortcut {
    width: 100%;
    padding: 0 15px 10px 15px;
    display: flex;
    justify-content: flex-end;
}

.tag {
    background-color: $primary-color;
    color: $sovis-white;
}

.categorias {
    @media only screen and (max-width: 500px) {
        display: none !important;
    }

    .column {
        padding: 0.25rem 0.75rem;
        font-size: 14px;
    }
}

.result-set {
    padding: 0.25rem 0.75rem;
    height: calc(100vh - 190px);
    overflow: auto;
}

.no-results {
    height: calc(100vh - 190px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: $text-color;
}

.add-btn,
.delete-btn {
    @media only screen and (max-width: 500px) {
        width: 100%;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    color: $sovis-white;
    font-size: 12px;
    width: 250px;
    height: 35px;
    text-align: center;
    margin-left: 0px;
    padding: 10px;
    border: none;
    border-radius: 6px;
    @include gradient-button();
}

.delete-btn {
    @include exclude-button-2();
}

.chart-container {
    .chart {
        width: 32%;
        height: auto;
        min-height: 375px !important;

        &.big-number {
            height: 182px !important;
            min-height: unset !important;
        }

        &.speedometer {
            min-height: unset;
        }

        &.line-chart {
            width: 65%;
        }

        &.full-size-chart {
            width: 100% !important;
        }
    }
    .pkry-sizer {
        width: 32%;
    }
    .pkry-gutter {
        width: 1%;
    }
}

.chart-toolbar {
    position: sticky;
    top: 0;
    background: $bg-color; /* Precisa pq se não os elementos vão passar por cima do sticky por ser transparente. */
    z-index: 4;
    /* Se for aumentar esse z-index, verificar dois possíveis pontos de falha
        - O modal do botão "Gerenciar gráficos"
        - O modal do botão de usuário no canto superior direito que ativa quando no modo mobile
    */

    .top-btn {
        height: 36px;
        margin-right: 10px !important;
    }

    .card {
        color: $darker-gray-color;

        .card-header-title {
            color: $darker-gray-color;
            justify-content: space-between;
            padding: 0.3rem;
        }

        .card-content {
            padding: 0.9rem;

            .card-content-top {
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
            }
        }
    }

    .filtro-header {
        display: flex;
        align-items: center;
    }

    .filtros-extras {
        font-size: 12px;
    }
}

@media only screen and (max-width: 1200px) {
    .chart-container {
        .chart {
            width: 49% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                height: 182px !important;
                min-height: unset !important;
            }

            &.speedometer {
                min-height: unset !important;
            }

            &.line-chart {
                width: 99% !important;
            }
        }

        .pkry-sizer {
            width: 49%;
        }
    }
}

@media only screen and (max-width: 860px) {
    .footer {
        display: none;
    }

    .chart-container {
        .chart {
            width: 49% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                height: 182px !important;
                min-height: unset !important;
            }

            &.speedometer {
                min-height: unset !important;
            }

            &.line-chart {
                width: 99% !important;
            }
        }

        .pkry-sizer {
            width: 49%;
        }
    }
}

@media only screen and (max-width: 760px) {
    .footer {
        display: none;
    }

    .chart-container {
        .chart {
            width: 100% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                min-height: unset !important;
            }

            &.speedometer {
                height: 300px;
            }

            &.line-chart {
                width: 100% !important;
            }
        }
        .pkry-sizer {
            width: 100%;
        }
    }

    .result-set {
        height: calc(100vh - 305px);
    }
}

.disabled {
    opacity: 0.4;
}
.svg-loader {
    fill: $sovis-black-light;
}
</style>
